export const BLOCK_MODEL_SCOPE = `
  mutation BlockModelScope($input: BlockModelScopeInput!) {
    blockModelScope(input: $input) {
      scopeKey
      modelId
      status
    }
  }
`
